// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrapper":"Breadcrumb_breadcrumbWrapper__toX09","icon":"Breadcrumb_icon__bNpew","title":"Breadcrumb_title__6T9rL"};